// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createTableMatchPoints_match__3-CC8 {\n  width: 100%;\n}\n\n.createTableMatchPoints_title__3sROv {\n  display: flex;\n  justify-content: space-between;\n}", ""]);
// Exports
exports.locals = {
	"match": "createTableMatchPoints_match__3-CC8",
	"title": "createTableMatchPoints_title__3sROv"
};
module.exports = exports;
